<template>
    <div id="forget">
        <form action="" class="form">
            <p>
                <input type="text" placeholder="手机号码" v-model.number.trim="forget.phone" :class="{'error-input':error.phone}" autocomplete="off">
            </p>
            <p>

                <input type="text" placeholder="验证码" v-model="forget.captcha" class="captcha" :class="{'error-input':error.captcha}" autocomplete="off">
                <span class="captcha-img"><img :src="captcha"  alt="" class="" @click="editCaptcha"></span>
            </p>
            <p class="getmess">
                <input type="mess" placeholder="短信验证码" v-model="forget.password" :class="{'error-input':error.password}" autocomplete="off">
                <span>获取验证码</span>
            </p>
            <p>
                <input type="text" placeholder="手机号码" v-model.number.trim="forget.phone" :class="{'error-input':error.phone}" autocomplete="off">
            </p>
            <p>
                <input type="text" placeholder="手机号码" v-model.number.trim="forget.phone" :class="{'error-input':error.phone}" autocomplete="off">
            </p>

        </form>
        <button class="btn">立即注册</button>
        <div class="mode">
            <router-link to="/login/logindo" tag="span">账号登陆</router-link> |
            <router-link to="/login/mess" tag="span">短信登陆</router-link> |
            <span>QQ</span> |
            <router-link to="/login/reg" tag="span">注册</router-link> |
            <router-link class="active" to="/login/forget" tag="span">忘记密码</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Forget",
        data (){
            return {
                captcha : '/api/captcha.html',
                error:{
                    phone : false,
                    password : false,
                    captcha : false
                },
                forget :{
                    phone : '',
                    password : '',
                    captcha : ''
                }
            }
        },methods : {
            editCaptcha (){

            }
        }
    }
</script>

<style lang="less">
    #forget{
        .captcha{width: 300px;}

        .captcha-img{position: absolute;right: 0;top:12px;height: 70px;width: 250px;z-index: 999;padding: 0 20px;border-left: 1px solid #efefef;
            img{width:100%;height:70px;}

        }
        .getmess{
            input{width:350px;}
            span{position: absolute;right: 0;top:12px;color:@theme;text-align:center;line-height:70px;width: 250px;height: 70px;z-index: 999;padding: 0 20px;border-left: 1px solid #efefef;}
        }
    }
</style>
